import * as React from 'react';

// UTILS
import { queryStringToObject } from '../../utils';

// PACKAGES
import { useLocation } from 'react-router-dom';

// COMPONENTS
import LoginModal from './LoginModal';

interface LoginTypes {}

export const Login: React.FC<LoginTypes> = ({}) => {
	const location = useLocation();
	const [params, setParams] = React.useState<{ [key: string]: any }>();

	const checkLocationParams = () => {
		const locationParams = location.state;

		const queryParams = queryStringToObject();
		
		setParams({ ...locationParams, ...queryParams });
	};

	React.useEffect(() => {
		checkLocationParams();
	}, []);

	return <LoginModal returnUrl={params ? params.returnUrl : ''} />;
};

export default Login;
